<template>
    <div id="aboutTasks">
        <Headers :headersText='headersText'></Headers>
        <div class="boxPadding">
            <div class="explain">
                <div class="text">
                    <div class="title">(1)做任务没有得到奖励？</div>
                    <div class="content">&emsp;a.您做任务的时候没有按照规定严格操作，例如：未在限定时间内完成；找错了图标，下载了非指定的应用；您未在钱大师的任务页内打开试玩应用；在试用该应用时，未允许该应用【无线局域网与蜂窝移动网】；未按规定试玩时间进行试玩；</div>
                    <div class="content">&emsp;b.在做任务的时候频繁切换网络.</div>
                    <div class="title">(2)任务列表中没有任务？</div>
                    <div class="content">&emsp;a.任务已被抢完，您可稍等片刻再进行刷新查看是否有新任务，或查看任务预告；</div>
                    <div class="content">&emsp;b.您的历史操作中有频繁违规行为，导致被判定为低权重用户，故被限制任务数量，可反馈客服解决；</div>
                    <div class="content">&emsp;c.部分地区因为作弊手段过多被限制任务数量，技术部门在优化中.</div>
                    <div class="title">(3)关于作弊用户</div>
                    <div class="content">作弊用户被封号以后将不能再正常做任务，并且账号无法恢复</div>
                </div>

                <img src="../../assets/images/img_52.png" alt="" id="bgs">
            </div>
        </div>
    </div>
</template>

<script>
    import Headers from '../../components/headers.vue'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'关于做任务',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #aboutTasks{
        .boxPadding{
            padding: 15px;
            .explain{
                width: 345px;
                background: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #DEDEDE;
                position: relative;
                .text{
                    margin: 15px;
                    color: #111111;
                    font-size: 13px;
                    line-height: 18px;
                    .title{
                        font-weight: bold;
                        &:not(:first-of-type){
                            margin-top: 15px;
                        }
                    }
                }
                #bgs{
                    width: 176px;
                    height: 189px;
                    position: absolute;
                    right: 20px;
                    bottom: 20px;
                }
            }
        }
    }
</style>